import { render } from "./usermodule.vue?vue&type=template&id=0ec56e42"
import script from "./usermodule.vue?vue&type=script&lang=js"
export * from "./usermodule.vue?vue&type=script&lang=js"

import "./usermodule.vue?vue&type=style&index=0&id=0ec56e42&lang=css"
script.render = render

export default script